const {
    IS_LOADING,
    BANNER_LIST_SUCCESS,
    BANNER_LIST_ERROR,
    BANNER_UPDATE_SUCCESS,
    BANNER_UPDATE_ERROR
} = require("../actions/Type");

const initialState = {
    loading: false,
    banner_list: {},
    banner_edit: {}
};

export const BannerManagementReducers = (state = initialState, { type, payload } = {}) => {
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case BANNER_LIST_SUCCESS:
            return {
                ...state,
                banner_list: payload,
                loading: false,
            };
        case BANNER_LIST_ERROR:
            return {
                ...state,
                banner_list: payload,
                loading: false,
            };
        case BANNER_UPDATE_SUCCESS:
            return {
                ...state,
                banner_edit: payload,
                loading: false,
            };
        case BANNER_UPDATE_ERROR:
            return {
                ...state,
                banner_edit: payload,
                loading: false,
            };
        default:
            return state;
    }
};
